import getLogger from '../../../util/logger';

const useCrazyEggConversions = () => {
  const { CE2 } = global;
  const logger = getLogger('crazyEgg');

  const onTrackConversionEvent = eventId => {
    if (typeof CE2?.converted === 'function') {
      CE2.converted(eventId);
    } else {
      logger.warn('CRAZY_EGG :: onTrackConversionEvent - No CE2', eventId);
    }
  };

  return {
    onTrackConversionEvent,
  };
};

export default useCrazyEggConversions;
